<app-block-list [blockIdList]="header"></app-block-list>

<div class="min-h-screen md:mx-auto w-full md:max-w-md">
  <app-block-list [blockIdList]="body"></app-block-list>
  <div
    *ngIf="body?.[0]?.block"
    class="hidden kiosk:block mt-24"
  >
    <div class="p-4 align-middle max-w-md mx-auto">
      <app-button-atom
        [size]="'L'"
        [type]="'primary'"
        (click)="submit()"
        [disabled]="!isFormValid"
        [label]="
          (isLastItem ? 'cart-funnel.confirm-my-order' : 'cart-funnel.button-continue') | translate
        "
      ></app-button-atom>
    </div>
  </div>
</div>
<div
  *ngIf="body?.[0]?.block"
  class="fixed md:sticky right-0 left-0 bottom-0 w-full shadow shadow-top bg-white"
>
  <div class="p-4 align-middle max-w-md mx-auto">
    <app-button-atom
      [size]="'L'"
      [type]="'primary'"
      (click)="submit()"
      [disabled]="!isFormValid"
      [label]="
        (isLastItem ? 'cart-funnel.confirm-my-order' : 'cart-funnel.button-continue') | translate
      "
    ></app-button-atom>
  </div>
</div>
